import { Component } from '@theme/component';
import { trackEvent } from '@theme/utilities';
export class BiblePage extends Component {
    constructor() {
        super();
        this.initProperties();
        this.bindEvents();
       
    }
    connectedCallback() {
        super.connectedCallback();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    initProperties() {
        this.bibleList = window.bibleList || [];
        this.pageType=this.getAttribute("data-page-type");
        const btnGroup = this.querySelector(".bible-video-btn-group");
        if (!btnGroup) return;
        this.latestShareDate = btnGroup.getAttribute("data-share-date");
        this.firstDate = btnGroup.getAttribute("data-first-date");
        this.lastDate = btnGroup.getAttribute("data-last-date");
        this.subBtnEl = this.querySelector(".sub-btn");
        this.shareEl = this.querySelectorAll(".share-bible");
        this.nextBtnEl = btnGroup.querySelector(".btn-next");
        this.prevBtnEl = btnGroup.querySelector(".btn-prev");
        this.hasNextMonth = this.nextBtnEl?.getAttribute('data-hasNextMonth') === 'true';
        this.hasPrevMonth = this.prevBtnEl?.getAttribute('data-hasPrevMonth') === 'true';
        this.tomorrowMonth = this.getRelativeMonth(this.latestShareDate, 1);
        this.yesterdayMonth = this.getRelativeMonth(this.latestShareDate, -1);
        this.latestBibleVideoEl = this.querySelector(".bible-video-today");
        this.uploadVideoEl = this.querySelector(".uploadVideo");
        this.iframeVideoEl = this.querySelector(".iframeVideo");
        this.bibleVideoListEl = this.querySelectorAll(".playListBtn");
        this.otherMonthBtnEl = this.querySelector(".otherMonthBtnGroup")?.querySelectorAll("a");
        const deferredMedia = this.querySelector("deferred-media");
        this.playBtnEl = deferredMedia?.querySelector("button");
        this.updateButtonDates();
        this.setupInitialButtonVisibility();
    }
    bindEvents() {
        this.prevBtnEl?.addEventListener("click", this.handlePrevClick.bind(this));
        this.nextBtnEl?.addEventListener("click", this.handleNextClick.bind(this));
        this.subBtnEl?.addEventListener("click", this.handleSubClick.bind(this));
        this.shareEl.forEach(share => {
            share.addEventListener("click", this.handleShareClick.bind(this));
        });
        this.bibleVideoListEl.forEach((video, index) => {
            video.addEventListener("click", () => {
                this.handleVideoListClick(index);
            });
        });
        this.otherMonthBtnEl.forEach((item) => {
            item.addEventListener("click", ()=>{
                trackEvent('bibleMonthClick')
            })
        })
    }
    handlePrevClick(e) {
        const clickDate = this.prevBtnEl.querySelector("span")?.getAttribute('data-date');
        trackEvent('biblePrevClick',{'clickDate': clickDate})
        if (this.shouldRedirectToMonthPage(clickDate, this.prevBtnEl)) {
            return;
        }
        const bibleData = this.findBibleDataByDate(clickDate);
        if (bibleData) {
            this.checkBibleData = bibleData;
            const index = this.findBibleIndexByDate(clickDate);
            this.resetData(clickDate, index);
        } else {
            this.prevBtnEl.style.display = "none";
        }
    }
    handleNextClick(e) {
        const clickDate = this.nextBtnEl.querySelector("span")?.getAttribute('data-date');
        trackEvent('bibleNextClick',{'clickDate': clickDate})
        if (this.shouldRedirectToMonthPage(clickDate, this.nextBtnEl)) {
            return;
        }
        const bibleData = this.findBibleDataByDate(clickDate);
        if (bibleData) {
            this.checkBibleData = bibleData;
            const index = this.findBibleIndexByDate(clickDate);
            this.resetData(clickDate, index);
        }
    }
    handleSubClick() {
        trackEvent('bibleSubClick')
        this.querySelector("#subscription-popup").style.display = "flex";
    }
    handleShareClick() {
        trackEvent('bibleShareClick')
        this.querySelector("#share-popup").style.display = "flex";
    }
    handleVideoListClick(index) {
        trackEvent('bibleVideoClick')
        this.checkBibleData = this.bibleList[index];
        this.updateNavigationButtonsVisibility(index);
        this.resetData(this.bibleList[index].date, index);
    }
    resetData(clickDate, nowIndex) {
        this.updateButtonVisibility(nowIndex);
        this.updateButtonDates();
        if (this.playBtnEl) {
            this.playBtnEl.click();
        }
        this.updateVideoContent();
        this.updateContent();
    }
    updateButtonDates() {
        if (this.checkBibleData) {
            this.nextDate = this.formatYMD(this.addDays(new Date(this.checkBibleData.date), 1));
            this.prevDate = this.formatYMD(this.addDays(new Date(this.checkBibleData.date), -1));
        } else {
            this.nextDate = this.formatYMD(this.addDays(new Date(this.latestShareDate), 1));
            this.prevDate = this.formatYMD(this.addDays(new Date(this.latestShareDate), -1));
        }
        if (this.nextBtnEl) {
            this.nextBtnEl.querySelector("span").innerHTML = this.nextDate;
            this.nextBtnEl.querySelector("span").setAttribute('data-date', this.nextDate);
        }
        if (this.prevBtnEl) {
            this.prevBtnEl.querySelector("span").innerHTML = this.prevDate;
            this.prevBtnEl.querySelector("span").setAttribute('data-date',this.prevDate);
        }
    }
    updateButtonVisibility(nowIndex) {
        // Hide prev button if at first item and no previous month
        const shouldHidePrev = (nowIndex <= 0 && !this.hasPrevMonth) || 
                              (this.firstDate && new Date(this.firstDate).getDate() !== 1 && 
                               this.firstDate === this.checkBibleData?.date && !this.hasPrevMonth);
        this.prevBtnEl.style.display = shouldHidePrev ? "none" : "block";
        // Hide next button if at last item and no next month
        const shouldHideNext = (nowIndex >= this.bibleList.length - 1 && 
                               new Date(this.latestShareDate).getMonth() + 1 === this.tomorrowMonth);   
        this.nextBtnEl.style.display = shouldHideNext ? "none" : "block";
    }
    updateNavigationButtonsVisibility(index) {
        this.prevBtnEl.style.display = index === 0 ? "none" : "block";
        this.nextBtnEl.style.display = index === this.bibleList.length - 1 ? "none" : "block";
    }
    setupInitialButtonVisibility() {
        const shouldShowNext = new Date(this.latestShareDate).getMonth() + 1 !== this.tomorrowMonth && this.hasNextMonth;
        this.nextBtnEl.style.display = shouldShowNext ? "block" : "none";
    }
    updateVideoContent() {
        if (!this.checkBibleData) return;
        const hasSocialVideo = !!this.checkBibleData.videoUrl;
        if (hasSocialVideo) {
            this.showIframeVideo();
        } else {
            this.showUploadVideo();
        }
    }
    showIframeVideo() {
        this.uploadVideoEl.style.display = "none";
        this.iframeVideoEl.style.display = "block";
        const iframeButton = this.iframeVideoEl.querySelector("button");
        if (iframeButton) {
            iframeButton.click();
        }
        const iframe = this.iframeVideoEl.querySelector("iframe");
        if (iframe) {
            iframe.src = this.checkBibleData.videoUrl;
        }
    }
    showUploadVideo() {
        this.uploadVideoEl.style.display = "block";
        this.iframeVideoEl.style.display = "none";
        const video = this.uploadVideoEl.querySelector("video");
        if (video) {
            const source = video.querySelector('source');
            if (source) {
                source.src = this.checkBibleData.video;
                video.load();
                video.style.setProperty('display', 'block', 'important');
                video.play().catch(e => console.log('Video play failed:', e));
            }
        }
    }
    updateContent() {
        if (!this.checkBibleData) return;
        const todayBibleImage = this.querySelector(".today-bible-image");
        if (todayBibleImage) {
            todayBibleImage.srcset = this.checkBibleData.featured_image;
            todayBibleImage.src = this.checkBibleData.featured_image;
        }
        const excerpt = this.querySelector(".excerpt");
        if (excerpt) {
            excerpt.innerHTML = this.checkBibleData.excerpt;
        }
    }
    // Helper methods
    getRelativeMonth(dateString, dayOffset) {
        const date = new Date(dateString);
        date.setDate(date.getDate() + dayOffset);
        return date.getMonth() + 1;
    }
    shouldRedirectToMonthPage(clickDate, buttonElement) {
        const clickMonth = this.getMonth(new Date(clickDate));
        const bibleMonth = buttonElement.getAttribute("data-bibleMonth");
        if (clickMonth !== bibleMonth) {
            this.pageType=='page'?window.location.href = `/pages/bible-${Number(clickMonth)}`:window.location.href = `/blogs/bible-${Number(clickMonth)}`;
            return true;
        }
        return false;
    }
    findBibleDataByDate(date) {
        return this.bibleList.find(x => x.date === date);
    }
    findBibleIndexByDate(date) {
        return this.bibleList.findIndex(x => x.date === date);
    }
    getMonth(d) {
        const y = d.getFullYear();
        const m = this.padZero(d.getMonth() + 1);
        return `${y}${m}`;
    }
    padZero(n) {
        return n < 10 ? '0' + n : n.toString();
    }
    formatYMD(d) {
        const y = d.getFullYear();
        const m = this.padZero(d.getMonth() + 1);
        const day = this.padZero(d.getDate());
        return `${y}-${m}-${day}`;
    }
    addDays(date, offset) {
        const utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        const newUtc = utc + offset * 24 * 60 * 60 * 1000;
        return new Date(newUtc);
    }
}

if (!customElements.get('bible-page')) {
    customElements.define('bible-page', BiblePage);
}